module.exports = __webpack_public_path__ + "static/gc-logo-1c7cc65d32b1f48b217cdc8b54ea74e3.png";